module.exports = __webpack_public_path__ + "img/Employee-Form.7e611b62.jpg";